import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import {
  FormState,
  FormStatus,
  getDefaultPaymentOptionId,
} from '../../../../utils/state/initialStateFactory';
import { FormContext } from '../../../../utils/context/contextFactory';
import { IUser } from '@wix/native-components-infra/dist/src/types/types';
import { setFieldsValuesInStorage } from '../../../../utils/storageFunctions';
import { ErrorHandlers } from '../errorHandlers/errorHandlers';
import { CouponsErrorType } from '../../../../types/errors';
import { bookingsLoginClick } from '@wix/bi-logger-wixboost-ugc/dist/src/v2';

export type OnLogin = (user?: IUser) => Promise<void>;

export function createOnLoginAction(
  {
    getControllerState,
    context: { formApi, settings, wixSdkAdapter, biLogger },
  }: ActionFactoryParams<FormState, FormContext>,
  errorHandlers: ErrorHandlers,
): OnLogin {
  return async (user) => {
    const [state, setState] = getControllerState();
    const { slotAvailability } = state;
    const { serviceId, startDate } = slotAvailability.slot!;

    biLogger.report(bookingsLoginClick({}));

    setFieldsValuesInStorage(wixSdkAdapter, {
      state: {
        valid: false,
        errors: {},
      },
      submission: {},
    });

    if (user) {
      try {
        const memberDetails = await formApi.getMemberDetails(user.id);
        const pricingPlanDetails = await formApi.getPricingPlanDetails({
          serviceId: serviceId!,
          startTime: startDate!,
        });
        const selectedPaymentOptionId = getDefaultPaymentOptionId(
          settings,
          state.service.payment,
          pricingPlanDetails,
        );

        setState({
          memberDetails,
          pricingPlanDetails,
          selectedPaymentOptionId,
          status: FormStatus.IDLE,
          overideDefaultFieldsValues: true,
        });
      } catch (error) {
        errorHandlers.addError(error);
        setState({ status: FormStatus.IDLE });
      }
    } else {
      errorHandlers.addError(CouponsErrorType.GENERAL_SERVER_ERROR);
    }
  };
}
